import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadFormCRM from '../../../../components/LeadForm/LeadFormCRM';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import HikalLeadForm from '../../../../components/LeadForm/HikalLeadForm';

function AziziVeniceHikal({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const images = [
        "/assets/images/projects/azizi-venice/1.webp",
        "/assets/images/projects/azizi-venice/2.webp",
        "/assets/images/projects/azizi-venice/3.webp",
        "/assets/images/projects/azizi-venice/4.webp",
        "/assets/images/projects/azizi-venice/5.webp",
        "/assets/images/projects/azizi-venice/6.webp"
    ];

    const poster = "/assets/images/projects/azizi-venice/1.webp";
    const webm = "/assets/images/projects/azizi-venice/hero.webm";
    const mp4 = "/assets/images/projects/azizi-venice/hero.mp4";

    return (
        <>
            <div>
                <NoiseBackground />
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/c1hp/azizi/venice"
                        : "/c1hp/azizi/venice/ar"
                    }
                />
                {/* LIMITED TIME OFFER */}
                <div className="padding-container my-5 py-5">
                    <Countdown />
                </div>

                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                دفعة مقدمة فقط
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "65,800 درهم"
                                            : (userInfo?.countryCode === "FR" || userInfo?.countryCode === "fr")
                                                ? "€18,000"
                                                : "$18,000"
                                    }
                                </span>
                                فقط!
                            </h1>
                        ) : (
                            <h1 className="text-center px-2 my-1 text-xl">
                                Down payment of just
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "AED 68,000"
                                            : (userInfo?.countryCode === "FR" || userInfo?.countryCode === "fr")
                                                ? "€18,000"
                                                : "$18,000"
                                    }
                                </span>
                                only!
                            </h1>
                        )
                    }
                </div>
            </div>
            {/* IMAGES */}
            <div className="flex w-full justify-center mb-5 pb-5">
                <video
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    preload="auto"
                    poster={poster}
                    width="350"
                    height="350"
                    className={`max-w-[350px] rounded-3xl`}
                >
                    <source src={webm} type="video/webm" />
                    <source src={mp4} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            {/* <ImageSlider images={images} /> */}

            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <HikalLeadForm
                    developer="Azizi"
                    project="Venice"
                    leadType="Apartment"
                    language={language === "ar" ? "Arabic" : "English"}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Retail"]}
                />
            </div>
            <Footer />
        </>
    );
}

export default AziziVeniceHikal;
